import type {InterfaceStrings} from './strings'

export const fr: InterfaceStrings = {
    nav: {
        beginSession: 'Commencer',
        faq: 'FAQ',
        pricing: 'Tarifs',
        legal: 'Mentions légales',
        signIn: 'Se connecter',
        viewPricing: 'Voir les tarifs',
        signOut: 'Se déconnecter',
        account: 'Compte',
        menu: 'Menu',
        closeMenu: 'Fermer le menu',
        mainNav: 'Navigation principale',
        sessions: {one: '{n} séance', other: '{n} séances'},
    },
    footer: {
        selfHypnosisFor: 'L’autohypnose pour',
        anxiety: 'L’anxiété',
        sleep: 'Le sommeil',
        stress: 'Le stress',
        confidence: 'La confiance en soi',
        focus: 'La concentration',
        learn: 'Comprendre',
        ericksonian: 'Qu’est-ce que l’hypnose ericksonienne',
        aiHow: 'Comment fonctionne l’hypnose par IA',
        vsMeditation: 'Hypnose ou méditation',
        methods: 'Méthodes',
        languages: 'Langues',
    },
    page: {
        cta: 'Commencer votre séance gratuite',
        hint: 'Votre première séance est offerte',
        exploreFurther: 'Pour aller plus loin',
        disclaimer:
            'Quies est un outil de bien-être pour la relaxation et l’exploration intérieure. Ce n’est pas un dispositif médical : il ne diagnostique, ne traite ni ne guérit aucune pathologie. En cas de détresse psychique, adressez-vous à un professionnel de santé.',
        transcript: 'Transcription',
        transcriptNote: 'Un extrait d’une vraie séance Quies, tel qu’il a été dit.',
        breadcrumb: 'Fil d’Ariane',
    },
    pricing: {
        selectPlan: 'Choisir cette offre',
        subscribe: 'S’abonner',
        perMonth: 'par mois',
        manageSubscription: 'Gérer mon abonnement',
        replayFree: 'Réécouter une séance passée est toujours gratuit.',
        offerLead: 'Chaque séance reprend là où la précédente s’est arrêtée.',
    },
    session: {
        chooseLanguage: 'Choisissez votre langue',
        changeLanguage: 'Changer de langue',
        changeVoice: 'Changer de voix',
        previewVoice: 'Écouter {voice}',
        stopPreview: 'Arrêter l’écoute',
        continue: 'Continuer',
        composing: 'Quies écrit votre séance',
        preparing: 'Votre méditation se prépare',
        pickingUp: 'reprise là où vous en étiez',
        today: 'Aujourd’hui',
        yesterday: 'Hier',
        loading: 'Chargement…',
        showEarlier: 'Afficher les précédents ({count})',
        tryDifferentApproach: 'Prendre un autre chemin',
        nothingAdded: 'Rien d’ajouté',
        purchaseConfirmed: 'Achat confirmé',
        firstSessionNote: 'Votre première séance est offerte. Vous vous connecterez avant de l’écouter.',
    },
    threshold: {
        title: 'Connectez-vous pour écouter',
        message: 'Votre première séance est offerte. Aucune carte n’est demandée.',
        google: 'Continuer avec Google',
        sendLink: 'Envoyez-moi un lien de connexion',
        sending: 'Envoi…',
        emailLabel: 'Adresse e-mail',
        or: 'ou',
        waitingTitle: 'Vérifiez votre messagerie',
        waitingBody: 'Nous avons envoyé un lien de connexion à {email}.',
        sendAgain: 'Envoyer de nouveau',
        googleInstead: 'Plutôt se connecter avec Google',
        codeLabel: 'Ou saisissez le code à 6 chiffres reçu par e-mail',
        codeSubmit: 'Continuer',
        codeSubmitting: 'Vérification…',
        codeWrong: 'Ce code n\'est pas le bon.',
        codeDead: 'Ce code ne fonctionne plus. Utilisez le lien de l\'e-mail, ou demandez-en un nouveau.',
        errors: {
            invalidEmail: 'Saisissez une adresse e-mail valide.',
            rateLimited: 'Trop de tentatives. Réessayez dans quelques minutes.',
            sessionError: 'Un problème est survenu avec votre connexion. Actualisez la page et réessayez.',
            sendFailed: 'L’e-mail n’a pas pu être envoyé. Veuillez réessayer.',
            sessionExpired: 'Votre connexion a expiré. Actualisez la page et réessayez.',
            generic: 'Un problème est survenu. Veuillez réessayer.',
        },
    },
    player: {
        play: 'Lecture',
        pause: 'Pause',
        playAgain: 'Réécouter',
        seek: 'Position',
        eyesClosed: 'Yeux fermés',
        openEyes: 'Ouvrir les yeux',
        paused: 'En pause',
        unavailable: 'Audio indisponible',
        untitled: 'Séance Quies',
    },
    failure: {
        turnFailed: 'Un problème est survenu de notre côté. Votre réponse est conservée.',
        reconnecting: 'Reconnexion…',
        refusalTitle: 'Prenons un autre chemin',
        refusal: 'Une partie de votre message n’a pas pu recevoir de réponse. Reformulez-le, ou envoyez-le de nouveau.',
        openElsewhere: 'Cette séance est aussi ouverte dans une autre fenêtre.',
        serviceDown: 'Quies est injoignable pour le moment. Rien de ce que vous avez fait n’est perdu.',
        sessionsUsedTitle: 'Vos séances ont été utilisées',
        voiceFailedTitle: 'Votre méditation est écrite',
        voiceFailed: 'Sa voix n’a pas pu être produite à l’instant. Rien n’est perdu, et relancer la voix ne coûte rien.',
        voiceStopped: 'La voix s’est arrêtée en chemin. Elle peut reprendre là où elle s’était arrêtée.',
        streamMissing: 'Votre méditation est prête, mais elle n’est pas arrivée jusqu’à cette page.',
        tapToListen: 'Touchez pour écouter',
        fileFailed: 'Cet enregistrement ne peut pas être lu. La voix peut être relancée depuis la méditation, sans frais.',
        recordingGone: 'Cet enregistrement n’est plus conservé.',
        purchaseCancelled: 'Achat annulé. Rien n’a été débité.',
        purchasePending: 'Votre paiement est confirmé. Vos séances mettent plus de temps que d’habitude à arriver.',
        checkoutFailed: 'Le paiement n’a pas pu aboutir. Rien n’a été débité.',
        sessionEnded: 'Cette séance est arrivée à son terme.',
        busy: 'Quies est très sollicité en ce moment. Votre réponse est conservée ; réessayez dans une minute.',
        tooLong: 'Cette séance dépasse désormais ce que Quies peut contenir. Elle vous a été recréditée.',
        notSaved: 'Cette étape n’a pas pu être enregistrée. Réessayez pour ne pas perdre le fil.',
        meditationRefused:
            'Cette méditation n’a pas pu être écrite telle que demandée. Reformulez-la, ou recommencez : cette séance vous sera recréditée.',
        meditationRefusedUncharged:
            'Cette méditation n’a pas pu être écrite telle que demandée. Reformulez-la, ou recommencez.',
        linkExpired: 'Votre lien de connexion a expiré. Demandez-en un nouveau.',
        oauthFailed: 'La connexion a été interrompue. Veuillez réessayer.',
        offline: 'Vous êtes hors ligne. Votre réponse partira dès votre retour.',
        voiceChanged: 'Votre voix n’est plus disponible ; une autre voix lira cette méditation.',
        voiceReturned: 'La voix n’a toujours pas pu être produite. Cette séance vous a été recréditée.',
        voiceFailedAgain: 'La voix n’a toujours pas pu être produite.',
        voiceResuming: 'La voix reprend…',
        voiceLimited: 'Plusieurs méditations ont déjà été lues pour vous dans l’heure. Réessayez un peu plus tard.',
        tryAgain: 'Réessayer',
        rephrase: 'Reformuler',
        resume: 'Reprendre',
        voiceAgain: 'Relancer la voix',
        listen: 'Écouter',
        continue: 'Continuer',
        begin: 'Commencer une séance',
        signIn: 'Se connecter',
        checkAgain: 'Vérifier de nouveau',
        sendLink: 'Envoyer un lien magique',
        useEmail: 'Utiliser plutôt l’e-mail',
    },
}
